import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import LoanApplyModal from "./LoanApplyModal";

const LoanApplyContext = createContext({
  openApply: () => {},
  closeApply: () => {},
});

export const LoanApplyProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaultLoanType, setDefaultLoanType] = useState("");
  const [defaultAmount, setDefaultAmount] = useState("");
  const [contextNote, setContextNote] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const openApply = useCallback(
    ({ loanType = "", amount = "", note = "" } = {}) => {
      setDefaultLoanType(loanType);
      setDefaultAmount(amount);
      setContextNote(note);
      setOpen(true);
    },
    []
  );

  const closeApply = useCallback(() => {
    if (isLoading) return;
    setOpen(false);
  }, [isLoading]);

  const value = useMemo(
    () => ({ openApply, closeApply }),
    [openApply, closeApply]
  );

  return (
    <LoanApplyContext.Provider value={value}>
      {children}
      <LoanApplyModal
        open={open}
        onClose={closeApply}
        defaultLoanType={defaultLoanType}
        defaultAmount={defaultAmount}
        contextNote={contextNote}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </LoanApplyContext.Provider>
  );
};

export const useLoanApply = () => useContext(LoanApplyContext);
